import { Pipe, PipeTransform } from "@angular/core";
import { Ruolo } from "../model/utente";

@Pipe({ name: 'RuoloPipe' })
export class RuoloPipe implements PipeTransform {
  transform(value: number): string {
    return Ruolo[value];
  }
};